import { render, staticRenderFns } from "./CompletedBookings.vue?vue&type=template&id=3b1d3d12"
import script from "./CompletedBookings.vue?vue&type=script&lang=js"
export * from "./CompletedBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports